const styles = (theme) => ({
  root: {
    overflowY: 'auto',
    maxHeight: '70vh',
    paddingTop: theme.spacing(1),
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    width: 200,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  multiSelect: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 0,
  },
  paperModal: {
    [theme.breakpoints.up('sm')]: {
      width: '70%',
    },
    margin: theme.spacing(1),
    padding: theme.spacing(2, 2, 3),
    marginRight: theme.spacing(4),
    outline: 'none',
  },
  tableContainerModal: {
    marginTop: theme.spacing(2),
    maxHeight: 'auto',
  },
  link: {
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  infoIcon: {
    cursor: 'help',
  },
})

export default styles
